import Button from "@mui/material/Button";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import * as React from "react";
import ContentEditable from "react-contenteditable";

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { "aria-label": ariaLabel } = {},
  } = props;

  return (
    <Button
      variant="text"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      className="data-input"
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <ContentEditable
        html={(label && label.toString()) || ""}
        disabled
        style={{ background: disabled ? "#D2D6DB80" : "transparent" }}
        className="data-input"
      />
    </Button>
  );
}

function ButtonDatePicker(props) {
  const [open, setOpen] = React.useState(false);

  return (
    <DatePicker
      slots={{ ...props.slots, field: ButtonField }}
      slotProps={{ ...props.slotProps, field: { setOpen } }}
      {...props}
      disabled={props?.isDisabled}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}

export default function DateCell({ value, setValue, isDisabled }) {
  const formattedDate = moment(value);
  const labelDate = value ? moment(value)?.format("DD/MM/YYYY") : "";
  return (
    <ButtonDatePicker
      label={labelDate}
      value={formattedDate}
      isDisabled={isDisabled}
      onChange={(newValue) => setValue(newValue?.toDate())}
    />
  );
}
